import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';
import withWidth from '@material-ui/core/withWidth';
import Grid from '@material-ui/core/Grid/Grid';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import FormHelperText from '@material-ui/core/FormHelperText';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import clsx from 'clsx';

const styles = (theme) => ({
  MuiFormControlRoot: {
    display: 'flex !important',
    [theme.breakpoints.up('sm')]: {
      marginTop: 15,
      marginBottom: 20,
    },
    '& label': {
      fontSize: 15,
    },
  },
  checkboxLabel: {
    fontSize: 15,
    paddingLeft: 15,
    paddingBottom: 12,
    [theme.breakpoints.down('xs')]: {
      paddingLeft: 12,
    },
  },
  emailNote: {
    fontSize: 15,
  },
  formHelperText: {
    marginLeft: 45,
    marginBottom: 15,
    fontSize: 15,
  },
  termsAndConditions: {
    margin: theme.spacing(2, 0),
  },
  checkboxError: {
    color: theme.palette.error.main,
  },
});

class AcceptDesign extends React.Component {
  static propTypes = {
    classes: PropTypes.object,
    noteLabel: PropTypes.string,
    notice: PropTypes.string,
    handleChange: PropTypes.func,
    width: PropTypes.string,
    handleChangeCheckboxApproval: PropTypes.func,
    approval: PropTypes.object,
    displayAcceptDesign: PropTypes.bool,
    termsAndConditionsLink: PropTypes.string,
    containerRef: PropTypes.object,
  };

  render() {
    const {
      classes,
      handleChangeCheckboxApproval,
      approval,
      displayAcceptDesign,
      termsAndConditionsLink,
      containerRef,
    } = this.props;

    const termsLink = `<a href="${termsAndConditionsLink}"
                              target="_blank">${t('acceptDesignScreen.termsAndConditionsLinkLabel')}</a>`;
    const termsAndConditions =
      ' ' + t('acceptDesignScreen.termsAndConditions', { termsAndConditionsLink: termsLink });

    return (
      <Grid container>
        <Typography className={classes.emailNote}>{t('acceptDesignScreen.emailNote')}</Typography>
        {displayAcceptDesign && (
          <Grid item xs={12} ref={containerRef}>
            <FormControlLabel
              className={classes.checkboxLabel}
              control={
                <Checkbox
                  name="approval"
                  checked={approval.value}
                  onChange={handleChangeCheckboxApproval}
                  color="primary"
                  className={clsx(approval.error && classes.checkboxError)}
                />
              }
              label={
                <Typography
                  variant="body2"
                  dangerouslySetInnerHTML={{
                    __html: t('acceptDesignScreen.checkedSelectionActive') + termsAndConditions,
                  }}
                  className={classes.termsAndConditions}
                />
              }
            />
            {approval.error && (
              <FormHelperText error={true} className={classes.formHelperText}>
                {t('acceptDesignScreen.selectionError')}
              </FormHelperText>
            )}
          </Grid>
        )}
      </Grid>
    );
  }
}

export default withWidth()(withStyles(styles, { name: 'AcceptDesign' })(AcceptDesign));
